/**
 * 主导航与地址栏同步。
 * 默认使用 Hash：`/#/swap`、`/#/bridge`、`/#/records`（刷新/直链不依赖 Nginx try_files）。
 * 若部署已配置 SPA 回退，仍支持 pathname `/swap` 等，并在首屏规范为上述 Hash。
 */
export const HS_PATH_SWAP = '/swap'
export const HS_PATH_BRIDGE = '/bridge'
export const HS_PATH_RECORDS = '/records'

function basePrefix() {
  const b = typeof process !== 'undefined' && process.env && process.env.BASE_URL
  if (!b || b === '/') return ''
  return b.endsWith('/') ? b.slice(0, -1) : b
}

/** 是否为「未定义」路由（在 SPA 已加载 index 的前提下展示全局 404） */
export function isNotFoundRoute() {
  if (typeof window === 'undefined') return false
  const p = stripBasePathname(window.location.pathname)
  const pathOk = new Set(['/', '', '/index.html', '/swap', '/bridge', '/records'])
  if (!pathOk.has(p)) return true
  const h = (window.location.hash || '').split('?')[0]
  if (!h || h === '#') return false
  const known = new Set([
    '#/swap',
    '#swap',
    '#/bridge',
    '#bridge',
    '#/records',
    '#records',
    '#invite',
    '#/invite',
    '#buyGas',
  ])
  if (known.has(h)) return false
  if (h.startsWith('#/')) return true
  if (h.startsWith('#')) return true
  return false
}

export function stripBasePathname(pathname) {
  const pre = basePrefix()
  if (!pre) return pathname || '/'
  if (pathname === pre || pathname === `${pre}/`) return '/'
  if (pathname.startsWith(`${pre}/`)) {
    const rest = pathname.slice(pre.length)
    return rest || '/'
  }
  return pathname || '/'
}

function hsHashUrl(relWithSlash) {
  return `${typeof window !== 'undefined' ? window.location.origin : ''}/#${relWithSlash}`
}

/** 根据 hash（优先）或 pathname 同步主界面；#invite、#buyGas 保留 */
export function applyPathnameToApp(ctx) {
  if (typeof window === 'undefined') return
  const rawHash = window.location.hash || ''
  const h = rawHash.split('?')[0]

  if (h === '#invite' || h === '#/invite') {
    ctx.currentPageRef.value = 'invite'
    return
  }
  if (h === '#buyGas') {
    ctx.setCrossType('naive')
    ctx.currentPageRef.value = 'swap'
    return
  }
  if (h === '#/swap' || h === '#swap') {
    ctx.setCrossType('naive')
    ctx.currentPageRef.value = 'swap'
    return
  }
  if (h === '#/bridge' || h === '#bridge') {
    ctx.setCrossType('usdt')
    ctx.currentPageRef.value = 'swap'
    return
  }
  if (h === '#/records' || h === '#records') {
    ctx.currentPageRef.value = 'recorder'
    return
  }

  const p = stripBasePathname(window.location.pathname)
  if (p === HS_PATH_SWAP) {
    ctx.setCrossType('naive')
    ctx.currentPageRef.value = 'swap'
    normalizeToHashUrl(HS_PATH_SWAP)
    return
  }
  if (p === HS_PATH_BRIDGE) {
    ctx.setCrossType('usdt')
    ctx.currentPageRef.value = 'swap'
    normalizeToHashUrl(HS_PATH_BRIDGE)
    return
  }
  if (p === HS_PATH_RECORDS) {
    ctx.currentPageRef.value = 'recorder'
    normalizeToHashUrl(HS_PATH_RECORDS)
    return
  }
  if (p === '/' || p === '') {
    ctx.setCrossType('usdt')
    ctx.currentPageRef.value = 'swap'
  }
}

function normalizeToHashUrl(relWithSlash) {
  const u = hsHashUrl(relWithSlash)
  try {
    if (window.location.href !== u) window.history.replaceState({ __hs: 1 }, '', u)
  } catch (_e) {}
}

export function pushHsPath(rel) {
  if (typeof window === 'undefined') return
  const u = hsHashUrl(rel)
  try {
    if (window.location.href !== u) window.history.pushState({ __hs: 1 }, '', u)
  } catch (_e) {}
}

/** 邀请页：整页 URL 规范为 `/#invite` */
export function replaceHsInvite() {
  if (typeof window === 'undefined') return
  const u = `${window.location.origin}/#invite`
  try {
    if (window.location.href !== u) window.history.replaceState({ __hs: 1 }, '', u)
  } catch (_e) {}
}
